import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { motion } from 'framer-motion';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import { messageMapper } from '../../utils';
import { Canvas } from '../Canvas/canvas';
import { Blob } from './blob';

export const Trigger = () => {
  const theme = useLlm(state => state.theme);
  const app = useLlm(state => state.app);
  const opened = useLlmView(state => state.opened);
  const { open } = useLlmView(state => state.actions);
  const label = useLabel();
  const collapsedWelcomeText = messageMapper(app?.contents.collapsedWelcomeText);
  const collapsedWelcomeTextCta = messageMapper(app?.contents.collapsedWelcomeTextCta);
  const collapsedWelcomeTextHover = messageMapper(app?.contents.collapsedWelcomeTextHover);
  const position = theme.trigger.position || 'bottom';
  return (
    <motion.nav
      className={getClassNames('llm__trigger', '-' + position)}
      initial={{ y: '200%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '200%', opacity: 0 }}
      transition={{ duration: .4 }}
      aria-label="Trigger"
      onClick={() => open()}
    >
      <button type="button"
        className={getClassNames('llm__trigger-btn', {
          'llm__trigger-btn--hover': collapsedWelcomeTextHover !== undefined,
        })}>
        <Blob />
        <span>{label('llm.button')}</span>
      </button>
      {!opened && (collapsedWelcomeText || collapsedWelcomeTextCta || collapsedWelcomeTextHover) && (
        <div className="llm__trigger-popup -llm-t-body2">
          {(collapsedWelcomeText || collapsedWelcomeTextCta) && (
            <motion.div
              className="llm__trigger-message"
              exit={{
                opacity: 0,
              }}>
              <Canvas />
              {collapsedWelcomeText}
              {collapsedWelcomeTextCta && (
                <button type="button" className="llm__trigger-cta">{collapsedWelcomeTextCta}</button>
              )}
            </motion.div>
          )}
          {collapsedWelcomeTextHover && (
            <motion.div
              className="llm__trigger-message"
              exit={{
                opacity: 0,
              }}>
              <Canvas />
              {collapsedWelcomeTextHover}
            </motion.div>
          )}
        </div>
      )}
    </motion.nav>
  );
};

